import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeContext from '../context/ThemeContext';
import '../styles/Terms.css';

const Contact = () => {
  const { accentColor } = useContext(ThemeContext);

  return (
   <div>
    <div className="terms-wrapper">
     <div className="terms-card">
     <Link className="termslink" to="/"> | Home | </Link>
     <h1 className="terms"> Contact</h1>
      <p>
      support@editfarmer.com
    </p>
    </div>
    </div>
    </div>
  );
};

export default Contact;
